export default {
  // 风险评估
  assessment: {
    entry: {
      pageTitle: "风险承受能力测评",
      riskText: "测一测您的风险承受能力有多少",
      btnText: "开始测评"
    },
    question: {
      pageTitle: "风险承受能力问卷",
      btnText: "提交测评",
      titleText: "请按照您实际情况选择",
      titleMark: "*号必填",
      derivative_clew: "与身份证件不一致，请确认",
      derivative_clew_two: "与适当性调查不一致，请确认",
      question: [
        {
          id: 1,
          title: "您的年龄介乎于？",
          isMust: true,
          choices: [
            {
              text: "(a) 18 ~ 35 周岁之间",
              name: "a"
            },
            {
              text: "(b) 36 ~ 44 周岁之间",
              name: "b"
            },
            {
              text: "(c) 44 ~ 55 周岁之间",
              name: "c"
            },
            {
              text: "(d) 55 ~ 65 周岁之间",
              name: "d"
            },
            {
              text: "(e) >65 周岁",
              name: "e"
            }
          ]
        },
        {
          id: 2,
          title: "您的教育程度是？",
          isMust: true,
          choices: [
            {
              text: "(a) 小学程度",
              name: "a"
            },
            {
              text: "(b) 中学程度",
              name: "b"
            },
            {
              // text: "(c) 预科或大专程度",
              text: "(c) 预科",
              name: "c"
            },
            {
              // text: "(d) 大学及以上",
              text: "(d) 大学程度",
              name: "d"
            }
          ]
        },
        {
          id: 3,
          title: "您是否有以下任何产品的投资经验或知识？（可多选）？",
          isMust: true,
          isCheck: true,
          ref: "checkBoxRef1",
          choices: [
            {
              text:
                "(a) 现金、存款、存款证、保本产品、香港政府债券、强积金、货币市场基金。",
              name: "a"
            },
            {
              text:
                "(b) 股票、债券、股票或债券基金(包括强积金，不包括货币市场基金)、投资相连保单。",
              name: "b"
            },
            {
              text:
                "(c) 衍生工具（如：期权、期货、认股权证(俗称「窝轮」))、对冲基金、结构性产品（如：累计认购期权、股票挂钩票据）",
              name: "c"
            }
          ]
        },
        {
          id: 4,
          title:
            "您有多少年投资于以下价值波动之投资产品(包括外币商品、结构投资产品、认股权证(俗称「窝轮」)、期权、期货)的经验，例如购入然后长期持有或经常买卖投资产品？",
          isMust: true,
          choices: [
            {
              text: "(a) 没有经验",
              name: "a"
            },
            {
              text: "(b) 少于1年",
              name: "b"
            },
            {
              text: "(c) 1至3年",
              name: "c"
            },
            {
              text: "(d) 超过3年",
              name: "d"
            }
          ]
        },
        {
          id: 5,
          title:
            "您有多少年投资于以下价值波动之投资产品(包括股票、单位信托基金、债券、投资相连保单等)的经验(例如购入然后长期持有或经常买卖投资产品？",
          isMust: true,
          choices: [
            {
              text: "(a) 没有经验",
              name: "a"
            },
            {
              text: "(b) 少于1年",
              name: "b"
            },
            {
              text: "(c) 1至3年",
              name: "c"
            },
            {
              text: "(d) 超过3年",
              name: "d"
            }
          ]
        },
        {
          id: 6,
          preTitle:
            "在一段时间之内，投资价值可升可跌，我们称之为波动。一般而言，风险愈高的投资，其潜在波动愈大，但潜在回报亦愈高。相反，风险愈低的投资，其潜在波动愈小，但潜在回报亦相对较低。",
          title: "在一般情况下，您会愿意投资于波动程度多大的投资产品？",
          isMust: true,
          choices: [
            {
              text: "(a) 波动超过 -30% 到 +30%",
              name: "a"
            },
            {
              text: "(b) 波动在 -25% 到 +25%之间",
              name: "b"
            },
            {
              text: "(c) 波动在 -15% 到 +15%之间",
              name: "c"
            },
            {
              text: "(d) 波动在 -5% 到 +5%之间",
              name: "d"
            }
          ]
        },
        {
          id: 7,
          title:
            "您打算用作于高盈证券投资的资金占流动资产净值（不包括自住物业）的百分比是多少？",
          isMust: true,
          choices: [
            {
              text: "(a) 少于10%",
              name: "a"
            },
            {
              text: "(b) 10% ~ 40%",
              name: "b"
            },
            {
              text: "(c) 40% ~ 60%",
              name: "c"
            },
            {
              text: "(d) 60%以上",
              name: "d"
            }
          ]
        },
        {
          id: 8,
          title: "您有多需要将投资项目变现，来满足对突发事件的流动资金需要？",
          isMust: true,
          choices: [
            {
              text: "(a) 我不一定会出售任何投资",
              name: "a"
            },
            {
              text: "(b) 我会出售不多于30%的投资",
              name: "b"
            },
            {
              text: "(c) 我会出售多于30%但不超过50%的投资",
              name: "c"
            },
            {
              text: "(d) 我会出售50%以上的投资",
              name: "d"
            }
          ]
        },
        {
          id: 9,
          preTitle:
            "在一般情况下，投资的年期越长，可承受的风险越高，而投资产品的价值亦会波动。",
          title: "当投资于产品时，您会愿意接受下列哪项投资年期？",
          posTitle: "有关投资产品的例子，请参阅问题3",
          isMust: true,
          choices: [
            {
              text: "(a) 多过5年",
              name: "a"
            },
            {
              text: "(b) 3年至5年",
              name: "b"
            },
            {
              text: "(c) 1年至3年",
              name: "c"
            },
            {
              text: "(d) 少于1年",
              name: "d"
            }
          ]
        },
        {
          id: 10,
          title: "以下哪项描述最适合形容您的投资目标？",
          isMust: true,
          choices: [
            {
              text:
                "(a) 防守型。希望保障我的资本及获得稍微高于存款的投资回报。我可承受低程度的资本损失。",
              name: "a"
            },
            {
              text:
                "(b) 收入型。希望定期收入及资本增长之间取得平衡，并可承受中等程度的资本损失。",
              name: "b"
            },
            {
              text:
                "(c) 资本增值型。我以长线资本增值为目标，并可承受大额度的资本损失。",
              name: "c"
            },
            {
              text:
                "(d) 进取型。我只寻求资本增值，同时可承受大幅度的资本价格波动。我愿意为了高回报而冒较高风险。",
              name: "d"
            }
          ]
        }
      ],
      toastMsg: "请根据您的实际情况选择"
    },
    result: {
      pageTitle: "风险承受能力测评",
      domText: [
        "您的得分是",
        "分",
        "总分100分",
        "您属于",
        "投资者",
        "风险承受程度:",
        "确定",
        "重新测评",
        "免责与客户声明",
        "请阅读完毕下述声明，并在弹窗底部点击按钮",
        "我已阅读免责声明，并同意客户声明",
        "不同意"
      ],
      textContent: [
        {
          title: "免责声明",
          content: [
            "1. 本问卷的结果是从您向高盈证券有限公司提供的资料，并根据若干普遍接纳的假设及合理估算而得出。本问卷采用的方法及取值仅供说明用途，本集团对本问卷所载资料及/或所得结果的准确性或完整性并不负责或承担任何法律责任。",
            "2. 本问卷及所得结果仅供您参考，并非购买或出售任何金融产品及服务的要约或招揽，亦不应被视为投资意见或推荐。",
            "3. 请注意，倘若您未能全面披露所有或任何有关您的个人状况（如财务状况）、不正确、不完整或过时的资料可能影响本集团评估您对投资风险的态度及承受能力。如您的状况出现变动而可能影响本问卷中任何问题的答案，我们极力建议您再次填写本问卷。"
          ]
        },
        {
          title: "客户声明",
          content: [
            "本人（等）谨此声明：本人（等）为本问卷所提供资料为真实、正确及全面，并同意上述的投资风险承受能力分析为正确。"
          ]
        }
      ]
    }
  },
  // 资金管理
  funds: {
    pageTitle: [
      "资金账户",
      "账户资金详情",
      "转入资金",
      "汇款对照信息",
      "上传汇款凭证",
      "订单详情",
      "资金账户列表",
      "资金划转记录",
	  "资金划转"
    ],
    domText: [
      "标准合约A账户",
      "连续合约B账户",
      "折算",
      "币种",
      "可转出金额合计",
      "可转出资金",
      "账户总金额",
      "账户余额",
      "我的银行卡",
      "资金记录",
      "资金流水", 
      "折算币种"
    ],
	  accountName:["期货账户","证券账户"],
    jsText: ["已绑定", "未绑定"],
    btnText: ["转入", "转出", "换汇", "账户详情"],
    currencyText: ["美元", "港币", "人民币"],
    orderDetail: {
      domText: ["转账凭证", "备注", "处理失败退款"],
      fieldsText: [
        "订单编号",
        "资金账户",
        "订单类型",
        "方式",
        "处理结果",
        "转入币种",
        "转出币种",
        "转入金额",
        "转出金额",
        "转入时间",
        "转出时间",
        "手续费",
        "到账金额",
        "预计到账",
        "到账时间"
      ],
      otherText: ["付款币种", "付款金额", "付款时间"],
      payText: ["汇款", "划转", "录入", "换汇", "资讯订单"]
    },
    copy: "账号复制成功",
    copyFail: "账号复制失败",
    fundsDetail: {
      domText: "更新时间",
      fieldsText: [
        "账户名",
        "账户类型",
        "账户资金",
        "美元账户",
        "美元账户可用资金",
        "港币账户",
        "港币账户可用资金",
        "人民币账户",
        "人民币账户可用资金"
      ]
    },
    into: {
      domText: [
        "我持有的银行卡",
        "请不要使用他人银行账户汇款，汇款人与期货账户持有人必须是同一人",
        "注意：根据香港证监会要求，汇款人和证券期货账户持有人必须是同一人，汇款银行账户的姓名必须与您的高盈国际（香港）账户姓名相同，不可使用他人姓名的银行账户汇款。",
        "第一步：准备港币/美元",
        "请确保您的银行账户拥有港币/美元，您可以通过网上银行或手机银行兑换成港币/美元（各银行货币兑换业务资费和营业时间不同，请联系兑换银行确认）",
        "第二步：转入港币/美元",
        "请将款项汇入下方指定的银行账户，推荐使用中国银行、工商银行、华夏银行进行汇款，到账成功率高。大陆的招商银行、交通银行、建设银行暂时不能使用，转账不能到账，银行汇款会失败被原路退回。",
        " 为保障您的资金安全，汇款后请立刻",
        "截屏并上传汇款凭证",
        "手机银行转账时请将带有具体汇款金额的1个或多个页面截图上传，凭证需包含汇款金额、汇款人姓名、收款人账号、收款人姓名",
        "请汇款至您的工银亚洲资金托管账户",
        "在您的姓名拼音前加上“GoingInternational”，均为大写字母",
        "您的资金托管账户默认为加密隐藏，查看请点击按钮",
        "请选择汇款银行",
        "入金指南",
        "按照下列信息填写汇款单",
        "手续费：同行免费",
        "到账时间：预计1~3个工作日内"
      ],
      bankList: [
        "大陆地区银行卡",
        "香港地区银行卡",
        "支持：港元、美元",
        "支持：港元、美元、人民币"
      ],
      fieldsText: [
        "收款人名称",
        "收款账户",
        "国家/地区",
        "收款人地址",
        "收款银行 （中文）",
        "收款银行 （英文）",
        "银行地址",
        "银行名称",
        "账户名称",
        "收款账号（港币）",
        "收款账号（美元）",
        "收款账号（人民币）"
      ],
      others: [
        "复制",
        "查看",
        "我已汇款，上传凭证",
        "申请成功",
        "知道了",
        "您的申请已收到，我们将在1个工作日内处理",
        "复制成功"
      ],
      tips: [
        "注意：",
        "为保障您的资金安全，汇款后请立刻截屏并上传汇款凭证；",
        "手机银行转账时请将带有具体汇款金额的1个或多个页面截图上传；",
        "凭证需要包含汇款金额、汇款人姓名、收款人账号、收款人姓名",
        "提示：请根据实际情况提供相关凭证，有助于我们给您提供更好的服务和体验"
      ]
    },
    credential: {
      domText: [
        "填写并上传汇款凭证",
        "提交",
        "人民币（离岸）",
        "请输入金额,并保留2位小数",
        "上传中",
        "资金转入订单提交成功",
        "预计到账时间1~3个工作日",
        "知道了"
      ],
      fields: ["汇款币种", "存入金额", "上传凭证", "请上传所选项的相关凭证"]
    },
    transferRecord:{
      domText:['取消订单','请输入交易密码','忘记交易密码？','是否取消资金划转订单？','请输入交易密码','该订单取消成功','温馨提示','暂不取消','确定','验证交易密码'],
      fields:['待处理','处理成功','处理失败','订单取消']
    }
  },
  // 银行卡
  bankCard: { 
    pageTitle: ["我的银行卡", "绑定银行卡"],
    domText: [
      "绑定银行卡",
      "解除绑定",
      "修改银行卡",
      "取消",
      "提示",
      "将银行卡解除绑定？",
      "注意：请务必绑定账户持有人同名银行卡",
      "下一步",
      "请先完成开户",
      "修改成功",
      "添加成功",
      "持有人",
      "银行账号凭证",
      "说明：请上传含持有人姓名和银行账号的银行卡或者结单"
    ],
    fields: ["银行名称", "银行账号", "支持的币种(可多选)"],
    placeholderText: [
      "请输入银行全称",
      "请输入",
      "如有，请填写",
      "例如中国银行(总行)BKCHCNBJXXX"
    ],
    btnText: '提交',
    accountTipText: "账户号码说明",
    bankNamePlaceholder: "请填写银行名称"
  },
  // 公告
  notice: {
    pageTitle: "公告",
    noticePublicText: "发布时间",
    domText: "公告无内容",
    loadingText: "PDF下载中"
  },
  // 隐私政策
  policy: {
    pageTitle: "个人资料(私隐)政策/私隐政策声明"
  },
  // 组件
  myComponent: {
    domText: "处理失败退款",
    typeText: ["转入", "转出", "付款"],
    statusText: ["待处理", "处理成功", "处理失败", "自动处理", "退款到账","已取消"],
    accountTypeText: ["A账户", "B账户"],
	dialogBtText:["暂不取消","确认"],
	dialogText:"是否取消出金订单？",
  dialogText1:"是否取消入金订单？",
	cancelBtn:"取消订单"
  },
  // 公共
  public: {
    contentText: [
      "没有更多了",
      "暂无数据",
      "参数错误",
      "请选择",
      "加载中",
      "加载失败，点击屏幕重试",
      "数据加载失败，点击",
      "重新加载"
    ]
  },
  poorNetwork: "当前网络不稳定，数据更新可能会延迟"
};
